module.exports = require('./dist/Tooltip.js');



//////////////////
// WEBPACK FOOTER
// ./~/dibs-react-tooltip/index.js
// module id = 270
// module chunks = 4 6 7 8 9 10 11 12 13 14 15 16 18 19 20 21 22 23 26 29 30 31 55 56